import React, { use, useEffect } from "react";
import { CompanyCompData } from "../../company";
import { get } from "http";
import { getCompDate } from "../../api";
import CompFinderItem from "./CompFinderItem/CompFinderItem";

interface Props {
  ticker: string;
}

const CompFinder = ({ ticker }: Props) => {
  const [compData, setCompData] = React.useState<CompanyCompData[]>();
  useEffect(() => {
    const getCompDataInit = async () => {
      const result = await getCompDate(ticker);
      setCompData(result?.data);
    };
    getCompDataInit();
  }, [ticker]);
  return (
    <>
      <div className="inline-flex rounded-md shadow-black/50 shadow-lg m-4">
        {compData?.map((ticker) => {
          return <CompFinderItem key={ticker.symbol} ticker={ticker.symbol} />;
        })}
      </div>
    </>
  );
};

export default CompFinder;
